import { useContext } from "react";
import { ArrowRight } from "lucide-react";
import Header from "../Header";
import { maleSetupVideo, setupVideo } from "../../utils/constants";
import { LanguageContext } from "../../utils/context/languageContext";
import { LanguageKeys } from "../../utils/languageKeys";
import { GenderType } from "../../utils/enums";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { useConfig } from "../../utils/context/configContext";
import { Gender } from "../../types/interfaces";

interface SetupScreenProps {
  gender: Gender;
  onNext?: () => void;
}

export default function SetupScreen({ gender, onNext }: SetupScreenProps) {
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();

	return (
		<div
			data-testid="educational-root"
			data-educational-step="3"
			className="flex h-full max-w-[28rem] mx-auto w-full p-[1rem] common-ui-main relative flex-col items-center   overflow-hidden max-w-md mx-auto bg-primary text-base"
			style={{ background: config?.style?.base?.backgroundColor }}
		>
			<div className="flex justify-start  max-w-md mx-auto w-full ">
				<Header noTitle />
			</div>
			<h2
				className="mb-[1rem] text-[32px]"
				style={{
					fontFamily: config?.style?.heading?.headingFontFamily || "SeriouslyNostalgic Fn",
					fontSize: config?.style?.heading?.headingFontSize || "32px",
					color: config?.style?.heading?.headingColor || "#000",
					fontWeight: config?.style?.heading?.headingFontWeight || "normal",
				}}
			>
				{translate?.(LanguageKeys.phonePlacement)}
			</h2>
			<p
				className="text-center text-gray-600 text-sm mt-1 max-w-[280px] mx-auto min-h-[40px]"
				style={{
					fontFamily: config?.style?.subheading?.subheadingFontFamily || "'Inter', sans-serif",
					fontSize: config?.style?.subheading?.subheadingFontSize || "14px",
					color: config?.style?.subheading?.subheadingColor || "#4b5563",
					fontWeight: config?.style?.subheading?.subheadingFontWeight || "normal",
				}}
			>
				{translate?.(LanguageKeys.phonePlacementDescription)}
			</p>
			<div className="relative w-full h-full flex flex-col items-center max-w-md pt-[1rem]">
				<div className="relative w-full h-auto">
					<video className="h-full w-full object-contain border-none" muted loop autoPlay playsInline>
						<source src={gender === GenderType.Male ? maleSetupVideo : setupVideo} type="video/mp4" />
					</video>
				</div>

				<div className="absolute bottom-[0] max-w-[28rem] mx-auto w-full left-0 right-0  flex justify-center max-w-md mx-auto">
					<div className="flex justify-end w-full">
						<SpecificButton buttonFunc={() => onNext?.()} data-testid="educational-next-btn" buttonText={translate?.(LanguageKeys.continue)} postfixIcon={<ArrowRight />} />
					</div>
				</div>
			</div>
		</div>
	);
}
